import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface ServiceSummaryRowProps {
  totalServices: number;
  prescribedServices: number;
  matchedServices: number;
  otherServices: number;
  totalAmount: number | string;
}

const padCount = (value: number): string => {
  const safe = Number.isFinite(value) ? value : 0;
  return String(safe).padStart(2, '0');
};

const ServiceSummaryRow: React.FC<ServiceSummaryRowProps> = ({
  totalServices,
  prescribedServices,
  matchedServices,
  otherServices,
  totalAmount,
}) => {
  const { t: tBilling } = useTranslation('billing_config');
  
  const amountNumber = Number(totalAmount || 0);

  return (
    <Box
      data-testid="service-summary-row"
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 1,
        fontWeight: 600,
        backgroundColor: '#f5f5f5',
        borderRadius: 2,
        fontSize: 15,
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        px: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: 999,
            border: '1px solid #d97706',
            color: '#d97706',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {tBilling('package_details.total_services')} : {padCount(totalServices)}
        </Box>
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: 999,
            border: '1px solid #3b82f6',
            color: '#3b82f6',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {tBilling('package_details.prescribed_services')} : {padCount(prescribedServices)}
        </Box>
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: 999,
            border: '1px solid #16a34a',
            color: '#16a34a',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {tBilling('package_details.matched_services')} : {padCount(matchedServices)}
        </Box>
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: 999,
            border: '1px solid #6b7280',
            color: '#6b7280',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {tBilling('package_details.others')} : {padCount(otherServices)}
        </Box>
      </Box>
      |
      <Box sx={{ textAlign: 'right', fontWeight: 600, color: '#444', fontSize: 15 }}>
        {tBilling('package_details.total_services_amount')}:{' '}
        {amountNumber.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </Box>
    </Box>
  );
};

export default ServiceSummaryRow;
